import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetRepairRequestList, Status } from '../../services/apiTypes';
import {
  fetchRepairRequestList as fetchRepairRequestListAPI,
  RepairRequestListParam,
} from './api';

interface RepairRequestListState {
  status: Status;
}

const initialState: RepairRequestListState = {
  status: 'idle',
};

export const fetchRepairRequestList = createAsyncThunk<
  GetRepairRequestList,
  RepairRequestListParam
>(
  'repairRequest/fetchRepairRequestList',
  async (params: RepairRequestListParam, { rejectWithValue }) => {
    try {
      return await fetchRepairRequestListAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const repairRequestListSlice = createSlice({
  name: 'repairRequestList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRepairRequestList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchRepairRequestList.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(fetchRepairRequestList.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default repairRequestListSlice.reducer;
